import { Avatar, Typography, Box } from "@mui/material";
import React from "react";
import HorizontalStack from "./util/HorizontalStack";
import Moment from "react-moment";
import UserAvatar from "./UserAvatar";
import { Link } from "react-router-dom";

const ContentDetails = ({ username, createdAt, edited, preview }) => {
  return (
    <HorizontalStack sx={{ alignItems: "center" }} spacing={1}>
      <UserAvatar width={40} height={40} username={username} />
      <Box>
        <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
          <Link
            color="inherit"
            underline="hover"
            onClick={(e) => {
              e.stopPropagation();
            }}
            to={"/users/" + username}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {username}
          </Link>
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Moment fromNow>{createdAt}</Moment> {edited && <>(Edited)</>}
        </Typography>
      </Box>
    </HorizontalStack>
  );
};

export default ContentDetails;
